export const SCHEDULE_AB_11_COLUMNS = {
  gridColumns: [
    {
      dataType: 'string',
      displayName: 'Legal Entity',
      propertyName: 'legalEntityId',
    },
    {
      allowedValues: [
        'Notes',
        'TaxRefunds',
        'InsuranceInterest',
        'ActionAgainst3rdParty',
        'OtherContingent',
        'PropertyInterest',
        'OtherProperty',
      ],
      dataType: 'enum',
      displayName: 'Type of Contingent Asset',
      propertyName: 'typeOfContingentAsset',
      queryType: 'ScheduleTypeOfContingentAsset'
    },
    {
      allowedValues: null,
      dataType: 'string',
      displayName: 'Description',
      propertyName: 'description',
    },
    {
      allowedValues: null,
      dataType: 'string',
      displayName: 'Current Value',
      propertyName: 'currentValue',
    },
    {
      allowedValues: null,
      dataType: 'string',
      displayName: 'Total Face Amount',
      propertyName: 'totalFaceAmount',
    },
    {
      allowedValues: null,
      dataType: 'string',
      displayName: 'Doubtful / Uncollectable',
      propertyName: 'doubtfulUncollectable',
    },
    {
      allowedValues: null,
      dataType: 'string',
      displayName: 'Tax Year',
      propertyName: 'taxYear',
    },
    {
      allowedValues: null,
      dataType: 'string',
      displayName: 'Nature of Claim',
      propertyName: 'natureOfClaim',
    },
    {
      allowedValues: null,
      dataType: 'string',
      displayName: 'Amount Requested',
      propertyName: 'amountRequested',
    },

    {
      allowedValues: null,
      dataType: 'bool',
      displayName: 'Appraised in the Last 12 Months',
      propertyName: 'appraisedInLastYear',
    },

    {
      allowedValues: ['No', 'All', 'Address', 'Name'],
      dataType: 'enum',
      displayName: 'Redact',
      propertyName: 'redact',
      queryType: 'RedactType'
    },
    {
      allowedValues: null,
      dataType: 'string',
      displayName: 'Footnote',
      propertyName: 'footnote',
    },
    {
      allowedValues: null,
      dataType: 'string',
      displayName: 'Entity Comments',
      propertyName: 'entityComments',
    },
  ],
};
